import { NgModule } from '@angular/core';
import { AngularFireModule } from '@angular/fire';
import { AngularFireAuthModule } from '@angular/fire/auth';
import { AngularFireDatabaseModule } from '@angular/fire/database';

import { environment } from 'src/environments/environment';

@NgModule({
    imports: [
        AngularFireModule.initializeApp(environment.firebase, 'the-scoreboard'),
        AngularFireAuthModule,
        AngularFireDatabaseModule,
    ],
    exports: [
        AngularFireModule,
        AngularFireAuthModule,
        AngularFireDatabaseModule,
    ],
    declarations: [],
})
export class FirebaseModule { }
